var render = function render(_c,_vm){return _c('ul',_vm._b({staticClass:"menu"},'ul',_vm.data.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }